import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import Tables from "../../Components/AdminStaff/Tables";
import AddStaff from "../../Components/AdminStaff/AddStaff";
import { toast } from "react-toastify";
import EditStaff from "../../Components/AdminStaff/EditStaff";
import DeactivateStaff from "../../Components/AdminStaff/DeactivateStaff";
import LinkUnlink from "../../Components/AdminStaff/LinkUnlink";
import StaffPermissionSetting from "../../Components/AdminStaff/StaffPermissionSetting";
import moment from "moment";
import { Form, Formik } from "formik";
import AddLocationModel from "../../Components/AdminStaff/AddLocationModal";
import SideModal from "../../Components/SideModal";
import ActivityLogsModal from "../../Components/ActivityLogs/ActivityLogsModal";
import { useGenericGet } from "../../utilities/useGenericGet";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SummaryCards from "../../Components/AdminStaff/SummaryCards";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { hasPermission } from "../../helpers";

const AdminStaff = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const user = useSelector((state) => state.UserReducer.user);
  const canManageStaffPermissions = hasPermission("MANAGE_STAFF_PERMISSION", user);

  const [selectedData, setSelectedData] = useState("");
  const [masterData, setMasterData] = useState();
  const [apiData, setApiData] = useState();
  const [isAddStaff, setIsAddStaff] = useState(false);
  const [key, setKey] = useState("");
  const [isEditStaff, setIsEditStaff] = useState(false);
  const [isDeactivateStaff, setIsDeactivateStaff] = useState(false);
  const [linkStaff, setLinkStaff] = useState(false);
  const [isStaffSummary, setIsStaffSummary] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [filter, setFilter] = useState("");
  const [attendanceFlag, setAttendanceFlag] = useState(false);
  const [staffPermission, setStaffPermission] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [summary, setSummary] = useState({
    total: 0,
    present: 0,
    absent: 0,
    salaryBudget: 0,
    pendingSalary: 0,
  });
  const [startDate, setStartDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [locationModel, setLocationModel] = useState(false);
  const initialValues = {
    startDate: moment(new Date()).format("YYYY-MM-DD"),
  };
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );

  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const fetchFunction = async (params) => {
    const query = `&propId=${property?.id}&s=${params.searchQuery || ""}&t=${params.filterType || ""}&filter=${filter}`;
    let url = `${Config.apiUrl}/staff/list/web?${query}`;

    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setMasterData(res?.data);
      filterDataByTab(res?.data, activeTab);
      setAttendanceFlag(res?.attendanceFlag);
      setSummary(res?.summary);
      setIsFocused(true);
    }
  };

  const getError = (res) => { };

  const filterDataByTab = (data, tab) => {
    if (!data) return;

    let filteredData;

    if (tab === "1") {
      // On Payroll - isOnPayroll === 1
      filteredData = data.filter((staff) => staff.isOnPayroll === 1);
    } else {
      // Contract Staff - isOnPayroll === 2
      filteredData = data.filter((staff) => staff.isOnPayroll === 2);
    }

    // Then filter by user role if user is SALES_HEAD (role 10)
    if (user?.role === Config.STAFF_ROLES.SALES_HEAD) {
      filteredData = filteredData.filter((staff) => staff.role === Config.STAFF_ROLES.SALESPERSON);
    }

    setApiData(filteredData);
  };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleResetFilters = () => {
    if (filtersApplied) {
      handleFilterChange(null);
      setFiltersApplied(false);
    }
  };

  useEffect(
    () => {
      const handler = setTimeout(() => {
        getListMutate({ searchQuery, filterType });
      }, 50);
      return () => {
        clearTimeout(handler);
      };
    },
    []
  );

  useEffect(() => {
    if (filter) {
      const handler = setTimeout(() => {
        getListMutate({ searchQuery: "", filterType: "" });
      }, 50);
      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter]);

  // Filter data when tab changes or user role changes
  useEffect(() => {
    if (masterData) {
      filterDataByTab(masterData, activeTab);
    }
  }, [activeTab, masterData, user?.role]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    getListMutate({ searchQuery, filterType });
  };

  //------- Add Staff -------
  const addStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAddStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addStaffLoading, mutate: addStaffMutate } = useMutation(
    addStaffFunction,
    {
      onSuccess: onAddStaffSuccess,
      onError: onAddStaffError,
    }
  );

  //------- Edit Staff -------
  const editStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsEditStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onEditStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editStaffLoading, mutate: editStaffMutate } = useMutation(
    editStaffFunction,
    {
      onSuccess: onEditStaffSuccess,
      onError: onEditStaffError,
    }
  );

  //------- Deactivate/Activate Staff -------
  const deactivateStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/toggle/status`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onDeactivateStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeactivateStaff(false);
      getListMutate({ searchQuery, filterType });
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onDeactivateStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateStaffLoading, mutate: deactivateStaffMutate } =
    useMutation(deactivateStaffFunction, {
      onSuccess: onDeactivateStaffSuccess,
      onError: onDeactivateStaffError,
    });

  //------- Link Property Staff -------
  const linkPropertyStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/staff/toggle`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onLinkPropertyeStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onLinkPropertyStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: linkPropertyStaffLoading,
    mutate: linkPropertyStaffMutate,
  } = useMutation(linkPropertyStaffFunction, {
    onSuccess: onLinkPropertyeStaffSuccess,
    onError: onLinkPropertyStaffError,
  });

  const onSummaryBoxClick = (data) => {
    let filteredData;
    if (data === "SP") {
      //Pending Salary
      setFilter(data);
    }
    else if (data === "AB") {
      setFilter("");
      //Offline
      filteredData = masterData.filter((staff) => staff.attendance === 0 && staff.status === 1);
      if (activeTab === "1") {
        filteredData = filteredData.filter((staff) => staff.isOnPayroll === 1);
      } else {
        filteredData = filteredData.filter((staff) => staff.isOnPayroll === 2);
      }

      setApiData(filteredData);
    }
    else if (data === "IA") {
      setFilter("");
      //Offline
      filteredData = masterData.filter((staff) => staff.status === 2);
      if (activeTab === "1") {
        filteredData = filteredData.filter((staff) => staff.isOnPayroll === 1);
      } else {
        filteredData = filteredData.filter((staff) => staff.isOnPayroll === 2);
      }

      setApiData(filteredData);
    }
    else {
      setFilter("");
      filterDataByTab(masterData, activeTab);
    }
  };

  //-------Staff Permission Set -------
  const permissionStaffFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/client/manage/staff/permissions`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const permissionStaffSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setStaffPermission(false);
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const permissionStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: permissionStaffLoading, mutate: permissionStaffMutate } =
    useMutation(permissionStaffFunction, {
      onSuccess: permissionStaffSuccess,
      onError: permissionStaffError,
    });

  //------- Add Latitude and Longitude -------
  const addLocationFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/staff/edit/reporting/location`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const addLocationSuccess = (data) => {
    setLocationModel(false);
    getListMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addLocationError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLocationLoading, mutate: addLocationMutate } =
    useMutation(addLocationFunction, {
      onSuccess: addLocationSuccess,
      onError: addLocationError,
    });


  const { mutate: getActivityLogsMutate, isLoading: logsLoading } = useGenericGet(
    user.token,
    (res) => {
      setActivityLogs(res?.data || []);
      setShowLogs(true);
    },
    () => toast.error("Failed to load logs")
  );

  const openLogs = (item) => {
    getActivityLogsMutate({
      url: `${Config.apiUrl}/activity-log/list`,
      params: `&doneBy=${item.id}&doneByUserType=${item.userType}`
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Staffs
            <Underline />
          </BoxTitle>
          <Filters
            submitHandler={submitHandler}
            initialValues={initialValues}
            setIsAddStaff={setIsAddStaff}
            setKey={setKey}
          />
        </BoxHead>
        <FloorTabs>
          <FloorTab
            key="unPaid"
            onClick={() => handleTabChange('1')}
            $active={activeTab === "1"}
          >
            On Payroll
          </FloorTab>
          <FloorTab
            key="paid"
            onClick={() => handleTabChange('2')}
            $active={activeTab === "2"}
          >
            Contract Staff
          </FloorTab>
        </FloorTabs>
        <SideModal
          isOpen={isAddStaff}
          onClose={() => setIsAddStaff(false)}
        >
          <AddStaff
            key={key}
            setIsAddStaff={setIsAddStaff}
            isAddStaff={isAddStaff}
            addStaffLoading={addStaffLoading}
            addStaffMutate={addStaffMutate}
            property={propertyList}
          />
        </SideModal>

        <SideModal
          isOpen={linkStaff}
          onClose={() => setLinkStaff(false)}
        >
          <LinkUnlink
            setLinkStaff={setLinkStaff}
            linkStaff={linkStaff}
            linkPropertyStaffLoading={linkPropertyStaffLoading}
            linkPropertyStaffMutate={linkPropertyStaffMutate}
            property={propertyList}
            selectedData={selectedData}
          />
        </SideModal>

        <SideModal
          isOpen={staffPermission}
          onClose={() => setStaffPermission(false)}
        >
          <StaffPermissionSetting
            setStaffPermission={setStaffPermission}
            staffPermission={staffPermission}
            permissionStaffLoading={permissionStaffLoading}
            permissionStaffMutate={permissionStaffMutate}
            selectedData={selectedData}
          />
        </SideModal>

        <SideModal
          isOpen={isEditStaff}
          onClose={() => setIsEditStaff(false)}
        >
          <EditStaff
            isEditStaff={isEditStaff}
            setIsEditStaff={setIsEditStaff}
            editStaffLoading={editStaffLoading}
            editStaffMutate={editStaffMutate}
            selectedData={selectedData}
            isDeactivateStaff={isDeactivateStaff}
            setIsDeactivateStaff={setIsDeactivateStaff}
          />
        </SideModal>

        {isDeactivateStaff && (
          <DeactivateStaff
            isDeactivateStaff={isDeactivateStaff}
            setIsDeactivateStaff={setIsDeactivateStaff}
            deactivateStaffLoading={deactivateStaffLoading}
            deactivateStaffMutate={deactivateStaffMutate}
            selectedData={selectedData}
          />
        )}

        <SideModal
          isOpen={showLogs}
          onClose={() => setShowLogs(false)}
        >
          <ActivityLogsModal
            isOpen={showLogs}
            onClose={() => setShowLogs(false)}
            logs={activityLogs}
          />
        </SideModal>

        <SideModal
          isOpen={locationModel}
          onClose={() => setLocationModel(false)}
        >
          <AddLocationModel
            setLocationModel={setLocationModel}
            locationModel={locationModel}
            addLocationLoading={addLocationLoading}
            addLocationMutate={addLocationMutate}
            selectedData={selectedData}
          />
        </SideModal>

        {(isLoading || isRefetching) && !isFocused && user.role !== Config.STAFF_ROLES.SALES_HEAD && (
          <SummarySkeletonLoading count={5} />
        )}
        {isFocused && summary && (
          <>
            {user.role !== Config.STAFF_ROLES.SALES_HEAD &&
              <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
            }
            <FilterTableWrapper>
              <FilterWrapper>
                <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                  <SearchFilterBox
                    options={searchOptions}
                    handleFilterChange={handleFilterChange}
                    handleClearFilters={handleClearFilters}
                  />
                </div>
              </FilterWrapper>
              {(!isLoading || !isRefetching) && data && (
                <TableWrapper>
                  <Tables
                    apiData={apiData}
                    selectedData={selectedData}
                    setSelectedData={setSelectedData}
                    setIsEditStaff={setIsEditStaff}
                    setIsDeactivateStaff={setIsDeactivateStaff}
                    setLinkStaff={setLinkStaff}
                    setIsStaffSummary={setIsStaffSummary}
                    setStaffPermission={setStaffPermission}
                    attendanceFlag={attendanceFlag}
                    setLocationModel={setLocationModel}
                    openLogs={openLogs}
                    user={user}
                    activeTab={activeTab}
                    canManageStaffPermissions={canManageStaffPermissions}
                  />
                  {(error || apiData?.length === 0) && !isLoading && (
                    <NotFoundModel />
                  )}
                </TableWrapper>
              )}
            </FilterTableWrapper>
          </>
        )}
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, setIsAddStaff, setKey }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddStaff(true);
            }}
          >
            {"Add Staff"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-primary-color flex space-x-1.5 justify-center items-center text-primary-color  rounded-md px-6  cursor-pointer bg-white hover:bg-hover-color py-2.5 y-1 text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
export default AdminStaff;